import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
// Place services
import {
  addPlaceCustomList,
  createPlace,
  deletePlace,
  deletePlaceCustomList,
  deletePlaceImage,
  getPlace,
  getPlaces,
  getTypes,
  PlaceCustomListById,
  placeCustomLists,
  placeStoreDetails,
  updatePlace,
  updatePlaceCustom,
} from '../../../services/PlaceServices/placeServices';
// SweetAlert2
import { config } from '../../../config/config';
const placeAdaptor = createEntityAdapter({});
const Alert = withReactContent(Swal);

const initialState = placeAdaptor.getInitialState({
  loading: false,
  update_loading: false,
  error: null,
  types: [],
  activities: [],
  cities: [],
  places: [],
  provinces: [],
  features: [],
  place_details: {},
  placeCustomLists: [],
  placeCustomListDetails: [],
});

export const removePlaceCustomList = createAsyncThunk(
  'places/removePlaceCustomList',
  async (id, { dispatch }) => {
    const { sweet_alert_basic } = config;

    try {
      const { isConfirmed } = await Alert.fire({
        title: 'آیا مطمئن هستید که این لیست مکان حذف شود؟',
        text: 'این عملیات قابل بازگشت نیست',
        ...sweet_alert_basic,
      });

      if (isConfirmed) {
        const { status } = await deletePlaceCustomList(id);

        if (status >= 200) {
          toast.success('لیست مکان با موفقیت حذف شد');
          dispatch(getPlaceCustomLists());
        }
      }
    } catch (ex) {
      console.log(ex);
      toast.error('خطا در حذف لیست مکان');
    }
  },
);
export const getAllPlaces = createAsyncThunk(
  'places/getAllPlaces',
  async ({ page, search, type }) => {
    try {
      const { data } = await getPlaces(page, search, type);
      return data.places;
    } catch (ex) {
      console.log(ex);
    }
  },
);

export const getPlaceById = createAsyncThunk('places/getPlaceById', async (placeId) => {
  try {
    const { data } = await getPlace(placeId);
    return data;
  } catch (ex) {
    console.log(ex);
  }
});

export const updatePlaceById = createAsyncThunk(
  'places/updatePlaceById',
  async ({ place_id, initialPlace }) => {
    try {
      const { status } = await updatePlace(place_id, initialPlace);
      if (status >= 200) {
        toast.success('جاذبه گردشگری ویرایش شد');
      }
    } catch (ex) {
      console.log(ex);
      if (ex.response.status > 400) {
        toast.error('مشکلی رخ داده است مجددا تلاش فرمایید');
      }
    }
  },
);

export const addNewPlace = createAsyncThunk('places/addNewPlace', async (data) => {
  try {
    const { status } = await createPlace(data);
    if (status >= 200) {
      toast.success('جاذبه گردشگری با موفقیت ایجاد شد');
      window.location.replace('/places');
    }
  } catch (ex) {
    console.log(ex);
  }
});

export const getPlaceStoreDetails = createAsyncThunk('places/getPlaceStoreDetails', async () => {
  try {
    const { data } = await placeStoreDetails();
    return data;
  } catch (ex) {
    console.log(ex);
  }
});

export const getTypeFeatures = createAsyncThunk('places/getTypeFeatures', async (initialData) => {
  try {
    const { data } = await getTypes(initialData);
    return data.types;
  } catch (ex) {
    console.log(ex);
  }
});

export const removePlace = createAsyncThunk('places/removePlace', async (place_id) => {
  const { sweet_alert_basic } = config;
  try {
    const { isConfirmed } = await Alert.fire({
      title: 'جاذبه گردشگری حذف شود؟',
      text: 'این عملیات بازگشت ناپذیر است آیا اطمینان دارید؟',
      ...sweet_alert_basic,
    });

    if (isConfirmed) {
      const { status } = await deletePlace(place_id);
      toast.success('مکان با موفقیت حذف شد');
      if (status >= 200) {
        window.location.reload();
      }
    }
  } catch (ex) {
    console.log(ex);
  }
});

export const removePlaceImage = createAsyncThunk('places/removePlaceImage', async (image_id) => {
  const { sweet_alert_basic } = config;
  try {
    const { isConfirmed } = await Alert.fire({
      title: 'تصویر حذف شود؟',
      text: 'این عملیات بازگشت‌ناپذیر است. آیا اطمینان دارید؟',
      showCancelButton: true,
      confirmButtonText: 'بله، حذف شود',
      cancelButtonText: 'خیر، انصراف',
      ...sweet_alert_basic,
    });

    if (isConfirmed) {
      const { status } = await deletePlaceImage(image_id);
      if (status >= 200) {
        toast.success('تصویر با موفقیت حذف شد');
        return true;
      }
    }
    return false;
  } catch (ex) {
    console.log(ex);
  }
});
export const getPlaceCustomLists = createAsyncThunk(
  'places/getPlaceCustomLists',
  async (initialData) => {
    try {
      const { data } = await placeCustomLists();
      console.log(data.data);
      return data.data;
    } catch (ex) {
      console.log(ex);
    }
  },
);
export const createPlaceCustomList = createAsyncThunk(
  'places/createPlaceCustomList',
  async (formData, { dispatch }) => {
    try {
      const { status } = await addPlaceCustomList(formData);

      if (status === 200 || status === 201) {
        toast.success('لیست انتخابی با موفقیت اضافه شد');
        dispatch(getPlaceCustomLists());
        window.location.replace('/suggestion-places');
      }
    } catch (error) {
      console.log(error);
      toast.error('خطا در ذخیره لیست جدید');
      throw error;
    }
  },
);
export const updatePlaceCustomList= createAsyncThunk(
  'places/updatePlaceCustomList',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const { data, status } = await updatePlaceCustom(id, formData);

      if (status >= 200 && status < 300) {
        toast.success("لیست پیشنهادی ویرایش شد")
        return data;
      }
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response?.data);
    }
  },
);

export const getPlaceCustomListById = createAsyncThunk(
  'places/getPlaceCustomListById',
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await PlaceCustomListById(id);
      return data.placeCustomList;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  },
);
export const placeSlice = createSlice({
  name: 'place',
  initialState,
  reducers: {
    placeTypes(state, { payload }) {
      return state;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllPlaces.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllPlaces.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.places = payload;
      })
      .addCase(addNewPlace.pending, (state) => {
        state.loading = true;
      })
      .addCase(addNewPlace.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addNewPlace.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(createPlaceCustomList.pending, (state) => {
        state.loading = true;
      })
      .addCase(createPlaceCustomList.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createPlaceCustomList.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getPlaceStoreDetails.fulfilled, (state, { payload }) => {
        const loadedType = payload.types.map((type) => {
          return { value: type.id, label: type.name };
        });
        const loadedActivites = payload.activities.map((activity) => {
          return { value: activity.id, label: activity.name };
        });
        const loadedCity = payload.cities.map((city) => {
          return { value: city.id, label: city.name };
        });
        const loadedProvince = payload.provinces.map((city) => {
          return { value: city.id, label: city.name };
        });

        state.types = loadedType;
        state.activities = loadedActivites;
        state.cities = loadedCity;
        state.provinces = loadedProvince;
      })
      .addCase(getPlaceById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPlaceById.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.place_details = payload;
      })
      .addCase(updatePlaceById.pending, (state) => {
        state.update_loading = true;
      })
      .addCase(updatePlaceById.fulfilled, (state) => {
        state.update_loading = false;
      })
      .addCase(getTypeFeatures.fulfilled, (state, { payload }) => {
        state.features = payload;
      })
      .addCase(getPlaceCustomLists.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPlaceCustomLists.fulfilled, (state, action) => {
        state.loading = false;
        state.placeCustomLists = action.payload;
      })
      .addCase(removePlaceCustomList.pending, (state) => {
        state.loading = true;
      })
      .addCase(removePlaceCustomList.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(removePlaceCustomList.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getPlaceCustomListById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPlaceCustomListById.fulfilled, (state, action) => {
        state.loading = false;
        state.placeCustomListDetails = action.payload;
      })
      .addCase(getPlaceCustomListById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'خطا در دریافت اطلاعات پیشنهاد';
      })

      .addCase(updatePlaceCustomList.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePlaceCustomList.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updatePlaceCustomList.rejected, (state, action) => {
        state.loading = false;
        toast.error('خطا در ویرایش لیست، لطفا دوباره تلاش کنید');
      });
  },
});
export const { selectAll, selectById, selectIds } = placeAdaptor.getSelectors(
  (state) => state.places,
);

export const { placeTypes } = placeSlice.actions;

export default placeSlice.reducer;
